var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"data-component":"teaserSkeleton","data-col-count":"3"}},[_vm._t("header"),_c('div',{attrs:{"data-skeleton-body":""}},_vm._l((_vm.skeletonElements),function(type,index){return _c('hp-teaser-skeleton-element',{key:type + index,attrs:{"type":type}})}),1),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }